import React from 'react';
import { Box, Paper, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default function SearchSection({ searchQuery = '', onSearchChange }) {
  return (
    <Box id="search" sx={{ mt: { xs: -8, md: -12 }, mb: 6, position: 'relative', zIndex: 10 }}>
      <Box maxWidth={700} mx="auto" px={2}>
        <Paper elevation={6} sx={{ borderRadius: 3, p: { xs: 2, md: 4 } }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Buscar por nombre del lugar"
            size="medium"
            value={searchQuery}
            onChange={(e) => onSearchChange && onSearchChange(e.target.value)}
            sx={{ background: '#fff' }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: 'action.active' }} />
                </InputAdornment>
              ),
            }}
          />
        </Paper>
      </Box>
    </Box>
  );
} 